import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { logout } from '../utils/auth';
import { FaUsersRectangle } from 'react-icons/fa6';
import { HiOutlinePencilSquare } from 'react-icons/hi2';
import { TiCreditCard } from 'react-icons/ti';
import { PiListBulletsFill } from 'react-icons/pi';
import { FaMobileScreenButton } from 'react-icons/fa6';
import { FaUser } from 'react-icons/fa';
import { MdVerified } from 'react-icons/md';
import { toast, ToastContainer, Slide } from 'react-toastify';
import { handleLogout } from '../utils/api';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/app-settings.css';

const AppSettings = () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const location = useLocation();
  const navigate = useNavigate();
  const email = localStorage.getItem('userEmail'); // default if missing
  const userInitial = email.charAt(0).toUpperCase();
  const [showDropdown, setShowDropdown] = useState(false);
  const isAdmin = location.state?.admin || false;
  const appGroup = localStorage.getItem('appGroup');
  const [menuType, setMenuType] = useState('multiple'); // 'standard' | 'multiple'
  const [offerTypes, setOfferTypes] = useState(['WMLC', 'Fielders']);

  const [venues, setVenues] = useState([]);

  const token = localStorage.getItem('token');
  const [selectedVenue, setSelectedVenue] = useState(
    localStorage.getItem('selectedVenue') || ''
  );

  const getAppType = (appType) => {
    switch (appType) {
      case 'MaxGaming':
        return 'Max Gaming';
      case 'Manly':
        return 'Manly Harbour Boat Club';
      case 'Montauk':
        return 'Montauk Tavern';
      case 'StarReward':
        return 'Star Reward';
      case 'Central':
        return 'Central Lane Hotel';
      case 'Sense':
        return 'Sense Of Taste';
      case 'North':
        return 'North Shore Tavern';
      case 'Hogan':
        return "Hogan's";
      case 'Ace':
        return 'Ace Rewards';
      case 'Queens':
        return 'Queens Hotel';
      case 'Brisbane':
        return 'Brisbane Brewing Co';
      case 'Bluewater':
        return 'Bluewater Captains Club';
      case 'Flinders':
        return 'Flinders Street Wharves';
      case 'Drinks':
        return 'Drinks HQ';
      default:
        return appType;
    }
  };

  useEffect(() => {
    const fetchVenues = async () => {
      try {
        const response = await axios.get(`${baseUrl}/admin/app-registries`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data && response.data.data) {
          setVenues(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching venues:', error);
      }
    };

    if (token && userType === 'admin') {
      fetchVenues();
    }
  }, [token]);

  useEffect(() => {
  const fetchOfferButtons = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/offer/button/get`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data?.success && response.data?.data) {
        const { menu_Type, filter_Type } = response.data.data;

        if (menu_Type === 'standard') {
          setMenuType('standard');
          setOfferTypes(['']); // reset
        } else {
          setMenuType('multiple');
          setOfferTypes(
            Array.isArray(filter_Type) && filter_Type.length
              ? filter_Type
              : ['']
          );
        }
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          'Failed to fetch offer buttons'
      );
    }
  };

  if (token) {
    fetchOfferButtons();
  }
}, [token]);

  const handleVenueChange = async (e) => {
    const newVenue = e.target.value;
    if (!newVenue) return;

    try {
      const response = await axios.post(
        `${baseUrl}/admin/token`,
        {
          appType: newVenue,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data?.data?.token) {
        // Save the new token
        const newToken = response.data.data.token;
        localStorage.removeItem('token');
        localStorage.setItem('token', newToken);

        // Update the selected venue after successful token update
        setSelectedVenue(newVenue);
        localStorage.removeItem('selectedVenue');
        localStorage.setItem('selectedVenue', newVenue);

        await handleLock();
      }
    } catch (error) {
      console.error('Error updating token:', error);
      toast.error('Failed to update venue');
    }
  };

  const userType = 'admin';

  const isActive = (path) => {
    return location.pathname === path;
  };

  const addOfferType = () => {
    setOfferTypes([...offerTypes, '']);
  };

  const removeOfferType = (index) => {
    setOfferTypes(offerTypes.filter((_, i) => i !== index));
  };

  const updateOfferType = (index, value) => {
    const updated = [...offerTypes];
    updated[index] = value;
    setOfferTypes(updated);
  };

  const handleUpdate = async () => {
    try {
      const payload =
        menuType === 'standard'
          ? {
              menu_Type: 'standard',
            }
          : {
              menu_Type: 'multiple',
              filter_Type: offerTypes.filter(
                (t) => typeof t === 'string' && t !== ''
              ),
            };

      const response = await axios.post(
        `${baseUrl}/offer/button/create`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data?.success) {
        toast.success(response.data.message || 'Updated successfully');
      } else {
        toast.error(response.data?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to update offer buttons'
      );
    }
  };

  const handleLock = async () => {
    try {
      const result = await handleLogout();
      if (result.success) {
        navigate('/dashboard');
      } else {
        toast.error(
          result.message || 'Failed to remove lock. Please try again.'
        );
      }
    } catch (error) {
      console.error('Error in handleLock:', error);
      toast.error(error.message || 'Failed to remove lock. Please try again.');
    }
  };

  return (
    <div className="dashboard-container">
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Slide}
        style={{
          zIndex: 9999,
          marginTop: '90px',
          fontSize: '14px',
          minWidth: '300px',
          textAlign: 'center',
        }}
      />
      {/* Header */}
      <header className="dashboard-header">
        <div className="s2w-logo" onClick={async () => await handleLock()}>
          <img src="/s2w-logo.png" alt="S2W Logo" />
        </div>

        <div
          style={{
            position: 'relative',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {userType === 'admin' && (
            <>
              <p
                style={{
                  position: 'absolute',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  fontWeight: 'bold',
                  color: '#002977',
                  fontSize: '20px',
                  margin: 0,
                }}
              >
                Admin
              </p>
              <div
                style={{
                  position: 'absolute',
                  right: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <span
                  style={{
                    fontWeight: '500',
                    color: '#002977',
                    fontSize: '15px',
                    fontWeight: 'bold',
                  }}
                >
                  Venue
                </span>
                <select
                  style={{
                    padding: '5px 10px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                    backgroundColor: '#F2F2F2',
                    cursor: 'pointer',
                    minWidth: '200px',
                  }}
                  className="form-select"
                  value={selectedVenue}
                  onChange={handleVenueChange}
                  required
                >
                  {venues.map(
                    (venue) =>
                      venue.appType === appGroup &&
                      venue.appName &&
                      venue.appName.map((app, index) => (
                        <option key={`${venue._id}-${index}`} value={app}>
                          {getAppType(app)}
                        </option>
                      ))
                  )}
                </select>
              </div>
            </>
          )}
        </div>

        <div className="user-section">
          <div
            className="user-avatar"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            {userInitial}
          </div>
          {showDropdown && (
            <div className="dropdown-menu">
              <p>{email}</p>
              <button className="logout-btn" onClick={() => logout(navigate)}>
                Logout
              </button>
            </div>
          )}
        </div>
      </header>

      {/* sidebar */}
      <aside className="sidebar-sa">
        {!isAdmin ? (
<>
<button
          style={{ fontSize: '12px' }}
          className={`sidebar-btn ${isActive('/approvals') ? 'active' : ''}`}
          onClick={() => navigate('/approvals')}
        >
          <FaUsersRectangle
            className={`sidebar-icon ${
              isActive('/approvals') ? '' : 'navy-icon'
            }`}
          />{' '}
          &nbsp; Approvals
        </button>
        <button
          style={{ fontSize: '12px' }}
          className={`sidebar-btn ${isActive('/manual-reg') ? 'active' : ''}`}
          onClick={() => navigate('/manual-reg')}
        >
          <HiOutlinePencilSquare
            className={`sidebar-icon ${
              isActive('/manual-reg') ? '' : 'navy-icon'
            }`}
          />{' '}
          &nbsp; Manual Registration
        </button>
        <button
          style={{ fontSize: '12px' }}
          className={`sidebar-btn ${isActive('/membership') ? 'active' : ''}`}
          onClick={() => navigate('/membership')}
        >
          <PiListBulletsFill
            className={`sidebar-icon ${
              isActive('/membership') ? '' : 'navy-icon'
            }`}
          />{' '}
          &nbsp; Club Package
        </button>

        <button
          style={{ fontSize: '12px' }}
          className={`sidebar-btn ${isActive('/app-settings') ? 'active' : ''}`}
          onClick={() => navigate('/app-settings')}
        >
          <FaMobileScreenButton
            className={`sidebar-icon ${
              isActive('/app-settings') ? '' : 'navy-icon'
            }`}
          />{' '}
          &nbsp; App Settings
        </button>

        <button
          style={{ fontSize: '12px' }}
          className={`sidebar-btn ${
            isActive('/payment-reporting') ? 'active' : ''
          }`}
          onClick={() => {
            navigate('/payment-reporting');
          }}
        >
          <MdVerified
            className={`sidebar-icon ${
              isActive('/payment-reporting') ? '' : 'navy-icon'
            }`}
          />{' '}
          &nbsp; Payment Reporting
        </button>
</>
        ):(
          <>
<button
          style={{ fontSize: '12px' }}
          className={`sidebar-btn ${
            isActive('/standard-admin') ? 'active' : ''
          }`}
          onClick={() => navigate('/standard-admin')}
        >
          <FaUser
            className={`sidebar-icon ${
              isActive('/standard-admin') ? '' : 'navy-icon'
            }`}
          />{' '}
          &nbsp; Users
        </button>
        <button
          style={{ fontSize: '12px' }}
          className={`sidebar-btn ${isActive('/admin-custom') ? 'active' : ''}`}
          onClick={() => navigate('/admin-custom')}
        >
          <TiCreditCard
            className={`sidebar-icon ${
              isActive('/admin-custom') ? '' : 'navy-icon'
            }`}
          />{' '}
          &nbsp; Custom Buttons
        </button>

        <button
          style={{ fontSize: '12px' }}
          className={`sidebar-btn ${isActive('/app-settings') ? 'active' : ''}`}
          onClick={() => navigate('/app-settings', { state: { admin: true } })}
        >
          <FaMobileScreenButton
            className={`sidebar-icon ${
              isActive('/app-settings') ? '' : 'navy-icon'
            }`}
          />{' '}
          &nbsp; App Settings
        </button>
          </>

        )}
        
      </aside>

      <main className="special-offers-container">
        <div className="special-offers-card">
          <h3 className="special-offers-title">Set Special Offers Menu</h3>

          <div className="menu-type-section" style={{ marginBottom: '50px' }}>
            <label>
              <input
                type="radio"
                name="menuType"
                style={{ accentColor: '#002977' }}
                checked={menuType === 'standard'}
                onChange={() => setMenuType('standard')}
              />{' '}
              Standard menu
            </label>
            <label>
              <input
                type="radio"
                name="menuType"
                style={{ accentColor: '#002977' }}
                checked={menuType === 'multiple'}
                onChange={() => setMenuType('multiple')}
                defaultChecked
              />{' '}
              Multiple special offer types
            </label>

            {menuType === 'multiple' && (
              <>
                {offerTypes.map((type, index) => {
                  const isFirst = index === 0;
                  const isLast = index === offerTypes.length - 1;

                  return (
                    <div className="offer-type-field" key={index}>
                      <label>{`Type ${index + 1}`}</label>
                      <div className="type-input-with-plus">
                        <input
                          type="text"
                          value={type}
                          onChange={(e) => updateOfferType(index, e.target.value)}
                        />

                        {!isFirst && (
                          <span
                            className="remove-icon"
                            onClick={() => removeOfferType(index)}
                          >
                            ×
                          </span>
                        )}

                        {isLast && (
                          <span className="add-icon" onClick={addOfferType}>
                            +
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}

                <div className="preview-app-section">
                  <div className="preview-app-label">Preview</div>
                  <div className="preview-app-buttons">
                    <button className="active">ALL</button>
                    {offerTypes.map((offer, idx) => (
                      <button key={idx}>{offer}</button>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="update-btn-app-wrapper">
            <button
              className="action-btn approve"
              style={{ width: '30%', marginLeft: '34%' }}
              onClick={handleUpdate}
            >
              Update
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AppSettings;
